{
  "labels": {
    "getFullAccess": "Get Full System Access",
    "getFullAccess2": "Get Full System Access",
    "filters": "Filters",
    "backTo": "Back to",
    "back": "Back",
    "backToMain": "Back to Main View",
    "noReferrer": "No previous page to go back to",
    "rooms": "Rooms",
    "interactiveDescription": "Come meet the project in an interactive experience",
    "lowerCaseRooms": "{{v, optional}} rooms",
    "cancel": "Cancel",
    "apply": "Apply",
    "area": "Area",
    "floors": "Floors",
    "floor": "Floor {{v, optional}}",
    "balcony": "Balcony",
    "liked": "Liked",
    "lowerCaseBalcony": "{{v, optional}}m² balcony",
    "buildings": "Buildings",
    "apt": "Apt {{v, optional}}",
    "squareMeters": "Square me",
    "yourName": "Your name",
    "emailAddress": "Email address",
    "phoneNumber": "Phone number",
    "contactAgent": "Contact agent",
    "contactUsTab" : "Contact Us",
    "leadFormConsentStart": "I agree to the use of details by",
    "leadFormConsentPrivacy": "privacy policy,",
    "leadFormConsentEula": "terms of use",
    "leadFormConsentEnd": "and confirmed receipt of mail from Africa Israel.",
    "exploreProject": "Explore Project",
    "exploreMap": "Click here to discover locations close to the project.",
    "or": "OR",
    "showcase": "Showcase",
    "theProject": "The Project",
    "promotion": "Promotion",
    "viewAptIn3D": "View apartment in 3D",
    "3Dtour": "3D Tour",
    "3Dtour1": "3D Tour",
    "3Dtours": "3D Tours",
    "balconyView": "Balcony View",
    "floorPlan": "Floor Plan",
    "inventory": "Inventory",
    "inventory2": "Inventory",
    "inventory3": "Inventory",
    "inventorySectionTitle": "Units for sale in the project",
    "inventorySectionTitleRent": "Units for rent in the project",
    "documents": "Documents",
    "share": "Share",
    "shareLink": "Share link",
    "shareLocation": "Share current location",
    "continue": "Continue",
    "m2": "{{v, optional}}m²",
    "fromM2": "from {{v, optional}}m²",
    "all": "All",
    "sale": "Sale",
    "building": "Building {{v, optional}}",
    "statusAvailable": "Available",
    "statusUnavailable": "Booked",
    "3D": "3D",
    "poweredBy": "Powered by",
    "explore": "Explore",
    "explore3DApartment": "Explore 3D Apartment",
    "backToBuilding": "Back to Building",
    "apartmentSpecifications": "Apartment Specifications",
    "applyNow": "Apply Now",
    "favorite": "Favorite",
    "aptDetails": "Apartment Details",
    "env": "Env.",
    "inv": "Inv.",
    "info": "Project",
    "discount": "Sale",
    "offersAvailable": "{{v}} offers available",
    "interactiveView": "Interactive view",
    "360view": "360° View",
    "apartmentsAvailable": "{{v}} apartments available",
    "checkInMinutes": "Check in {{v}} minutes",
    "progressMap": "Progress Map",
    "timeline": "Project Timeline",
    "about": "About",
    "interactive": "Interactive",
    "interactive2": "Interactive",
    "promotions": "Special offers",
    "specifications": "Specifications",
    "gallery": "Gallery",
    "map": "Map",
    "nearbyPlaces": "Nearby Places",
    "transport": "Transport",
    "shopping": "Shopping",
    "educations": "Educations",
    "roadmap": "Roadmap",
    "satellite": "Satellite",
    "library": "Library",
    "preschool": "Preschool",
    "primary_school": "Primary School",
    "school": "School",
    "secondary_school": "Secondary School",
    "university": "University",
    "asian_grocery_store": "Asian Grocery Store",
    "auto_parts_store": "Auto Parts Store",
    "bicycle_store": "Bicycle Store",
    "book_store": "Book Store",
    "butcher_shop": "Butcher Shop",
    "cell_phone_store": "Cell Phone Store",
    "clothing_store": "Clothing Store",
    "convenience_store": "Convenience Store",
    "department_store": "Department Store",
    "discount_store": "Discount Store",
    "drugstore": "Drugstore",
    "electronics_store": "Electronics Store",
    "food_store": "Food Store",
    "furniture_store": "Furniture Store",
    "gift_shop": "Gift Shop",
    "grocery_store": "Grocery Store",
    "hardware_store": "Hardware Store",
    "home_goods_store": "Home Goods Store",
    "home_improvement_store": "Home Improvement Store",
    "jewelry_store": "Jewelry Store",
    "liquor_store": "Liquor Store",
    "market": "Market",
    "pet_store": "Pet Store",
    "shoe_store": "Shoe Store",
    "shopping_mall": "Shopping Mall",
    "sporting_goods_store": "Sporting Goods Store",
    "store": "Store",
    "supermarket": "Supermarket",
    "warehouse_store": "Warehouse Store",
    "wholesaler": "Wholesaler",
    "airport": "Airport",
    "airstrip": "Airstrip",
    "bus_station": "Bus Station",
    "bus_stop": "Bus Stop",
    "ferry_terminal": "Ferry Terminal",
    "heliport": "Heliport",
    "international_airport": "International Airport",
    "light_rail_station": "Light Rail Station",
    "park_and_ride": "Park and Ride",
    "subway_station": "Subway Station",
    "taxi_stand": "Taxi Stand",
    "train_station": "Train Station",
    "transit_depot": "Transit Depot",
    "transit_station": "Transit Station",
    "truck_stop": "Truck Stop",
    "learnMore": "Learn more",
    "readMore": "Read more",
    "readLess": "Read less",
    "showMore": "Show more",
    "showLess": "Show less",
    "seeMore": "See more",
    "parks": "Parks",
    "hospitals": "Hospitals",
    "restaurants": "Restaurants",
    "gyms": "Gyms",
    "pharmacies": "Pharmacies",
    "entertainment": "Entertainment",
    "banks": "Banks",
    "park": "Park",
    "garden": "Garden",
    "national_park": "National Park",
    "botanical_garden": "Botanical Garden",
    "picnic_ground": "Picnic Ground",
    "state_park": "State Park",
    "wildlife_park": "Wildlife Park",
    "wildlife_refuge": "Wildlife Refuge",
    "hospital": "Hospital",
    "restaurant": "Restaurant",
    "afghani_restaurant": "Afghani Restaurant",
    "african_restaurant": "African Restaurant",
    "american_restaurant": "American Restaurant",
    "asian_restaurant": "Asian Restaurant",
    "barbecue_restaurant": "Barbecue Restaurant",
    "brazilian_restaurant": "Brazilian Restaurant",
    "breakfast_restaurant": "Breakfast Restaurant",
    "brunch_restaurant": "Brunch Restaurant",
    "buffet_restaurant": "Buffet Restaurant",
    "chinese_restaurant": "Chinese Restaurant",
    "dessert_restaurant": "Dessert Restaurant",
    "fast_food_restaurant": "Fast Food Restaurant",
    "fine_dining_restaurant": "Fine Dining Restaurant",
    "indian_restaurant": "Indian Restaurant",
    "indonesian_restaurant": "Indonesian Restaurant",
    "italian_restaurant": "Italian Restaurant",
    "japanese_restaurant": "Japanese Restaurant",
    "mediterranean_restaurant": "Mediterranean Restaurant",
    "mexican_restaurant": "Mexican Restaurant",
    "middle_eastern_restaurant": "Middle Eastern Restaurant",
    "pizza_restaurant": "Pizza Restaurant",
    "ramen_restaurant": "Ramen Restaurant",
    "seafood_restaurant": "Seafood Restaurant",
    "spanish_restaurant": "Spanish Restaurant",
    "sushi_restaurant": "Sushi Restaurant",
    "thai_restaurant": "Thai Restaurant",
    "turkish_restaurant": "Turkish Restaurant",
    "vegan_restaurant": "Vegan Restaurant",
    "vegetarian_restaurant": "Vegetarian Restaurant",
    "vietnamese_restaurant": "Vietnamese Restaurant",
    "steak_house": "Steak House",
    "gym": "Gym",
    "fitness_center": "Fitness Center",
    "sports_club": "Sports Club",
    "sports_complex": "Sports Complex",
    "sports_activity_location": "Sports Activity Location",
    "athletic_field": "Athletic Field",
    "pharmacy": "Pharmacy",
    "adventure_sports_center": "Adventure Sports Center",
    "amphitheatre": "Amphitheatre",
    "amusement_center": "Amusement Center",
    "amusement_park": "Amusement Park",
    "aquarium": "Aquarium",
    "banquet_hall": "Banquet Hall",
    "barbecue_area": "Barbecue Area",
    "bowling_alley": "Bowling Alley",
    "casino": "Casino",
    "childrens_camp": "Children's Camp",
    "comedy_club": "Comedy Club",
    "cycling_park": "Cycling Park",
    "dance_hall": "Dance Hall",
    "event_venue": "Event Venue",
    "ferris_wheel": "Ferris Wheel",
    "hiking_area": "Hiking Area",
    "karaoke": "Karaoke",
    "movie_theater": "Movie Theater",
    "night_club": "Night Club",
    "opera_house": "Opera House",
    "philharmonic_hall": "Philharmonic Hall",
    "planetarium": "Planetarium",
    "plaza": "Plaza",
    "roller_coaster": "Roller Coaster",
    "skateboard_park": "Skateboard Park",
    "tourist_attraction": "Tourist Attraction",
    "video_arcade": "Video Arcade",
    "water_park": "Water Park",
    "zoo": "Zoo",
    "bank": "Bank",
    "atm": "ATM",
    "coffee_shop": "Coffee shop",
    "mapPage": "Map view",
    "showcasePage": "3D showcase",
    "menu": "Menu",
    "apartment": "Apartment",
    "fromPrice": "from ₪{{v}}",
    "moreInfo": "I need more info",
    "detailsSent": "Details sent",
    "noPriceSpecified": "No price specified",
    "aptNumber": "Apartment {{v}}",
    "aptWithRooms": "Apartment with {{v}} rooms",
    "penthouseAptWithRooms": "Penthouse ({{v}} rooms)",
    "type": "Type",
    "price": "Price",
    "patio": "Garden Apartment",
    "ground": "Ground",
    "studioLoft": "Studio Loft",
    "cottage": "Private House",
    "penthouse": "Penthouse",
    "duplex": "Duplex",
    "apartmentUnit": "Housing Unit",
    "offices": "Offices",
    "stores": "Stores",
    "clinics": "Clinics",
    "commercialWarehouses": "Warehouses",
    "commercialPlots": "Commercial Plots",
    "industrialStructures": "Industrial Buildings",
    "venues": "Halls/Venues",
    "agriculturalPlots": "Agricultural Farm",
    "commercialGeneral": "General Commercial",
    "vacationApartments": "Vacation Rentals",
    "parkingPlaces": "Parking Space",
    "apartmentSwapping": "Apartment Exchange",
    "plots": "Plots",
    "officeBuildings": "Office Building",
    "businessesForSale": "Businesses for Sale",
    "parkingPlots": "Parking Lot",
    "twofamilyDwelling": "Two-Family House",
    "general": "General",
    "sublet": "Sublet",
    "residentialBuilding": "Residential Building",
    "warehouses": "Warehouse",
    "estate": "Estate/Property",
    "trailers": "Mobile Home",
    "basementParterres": "Ground Floor/Parterre",
    "triplex": "Triplex",
    "auxiliaryPlots": "Auxiliary Farm",
    "basement": "Basement",
    "studio": "Studio",
    "hotel": "Hotel",
    "assistedLiving": "Assisted Living",
    "jointWorkspace": "Shared Workspace",
    "purchaseGroup": "Purchase group",
    "projectGallery": "Project gallery",
    "showAllPhotos": "Show all photos",
    "nowOnSale": "Now on sale",
    "forFurtherInfo": "For further information about the project",
    "submit": "Submit",
    "priceBy": {
      "total": "Total",
      "m2": "Per m²"
    },
    "startingFromPerSquareMeters": "from ₪{{v}} per m²",
    "startingFromMoney": "from ₪{{v}}",
    "scheduleSystemDemo": "Schedule a System Demo",
    "scheduleSystemDemoDescription": "Leave your details to schedule a meeting with a sales representative, where you'll receive project information and access to the full 3D system",
    "bookMeeting": "Book a Meeting",
    "dummyApartmentsDisclaimer": "This simulation shows sample apartments, not the project's actual inventory",
    "callUsNow": "Call us now",
    "tapNumberBelow": "Tap the number below to call us directly. We're here to help you.",
    "noSms": "SMS cannot be sent to this number",
    "showPhoneNumber": "Show phone number",
    "zoomIn": "Zoom In",
    "zoomOut": "Zoom Out",
    "resetZoom": "Reset zoom",
    "lockedBuildingTooltipText": "This simulation shows sample apartments, not the project's actual inventory",
    "lockedBuildingTooltipChip": "Get access to the full system",
    "otherProjects": "Get information about other projects of the company"
  },
  "time": {
    "day": "day",
    "days": "days",
    "hour": "hour",
    "hours": "hours",
    "minute": "minute",
    "minutes": "minutes",
    "second": "second",
    "seconds": "seconds"
  },
  "info": {
    "foundApartments": "{{count}} Apartments found",
    "penthausesLeft": "{{count}} Penthauses left!",
    "talkAndConsult": "Talk and consult with us for better results with your business",
    "messageSent": "Message sent!",
    "messageSentDescription": "Your message is on its way. We'll reach out to you soon. Exciting times ahead!",
    "projectsOffersDescription": "Get information about other projects in the area",
    "requiredField": "Please fill this area.",
    "consentRequired": "You must check the checkbox to continue",
    "invalidEmail": "The email address is invalid.",
    "invalidPhone": "The phone number is invalid.",
    "failedToSendMessage": "Failed to send message",
    "greatChoice": "Great Choice! Let's Get Started on Your New Home",
    "greatChoiceDescription": "You're one step closer to your new home. Fill in your details, and our team will get in touch with exclusive offers and more information.",
    "promotionsDescription": "Explore special promotions on newly constructed buildings, with limited-time deals that make owning your dream home easier.",
    "promotionsLeadDescription": "Send us a message to save the discount!",
    "leadMessageSent": "The message was sent successfully!",
    "leadMessageThankyou": "Thank you for your inquiry, our representative will get back to you as soon as possible.",
    "leadMessageExplore": "Get information about other projects in the area",
    "promotionalLabelDefault": "Find out more about other projects in the area",
    "specificationsDescription": "Detailed information on building materials, finishes, and high-quality installations designed for modern living.",
    "inventoryDescription": "View the apartments",
    "aboutTheProject": "About the project",
    "aboutClient": "About the client",
    "previewMessage": "This is a preview. Forms and interactive components will not work until approved."
  },
  "specs": {
    "spec1": "Unique environmental development and green spaces that combine elements of sport and lifestyle",
    "spec2": "Private storage for selected apartments in an underground parking lot",
    "spec3": "Luxurious and double-height lobby",
    "spec4": "Multifunctional residents' club, including a kitchenette, charging stations, and garden exit door",
    "spec5": "Luxurious and fast elevators combined with stainless steel and mirrors",
    "spec6": "Green construction according to standard 5281",
    "spec7": "Spacious underground parking",
    "spec8": "Building preparation for an electric vehicle charging system",
    "spec9": "Home automation system for controlling the living space: lighting, electric shutter, boiler and air conditioning",
    "spec10": "Preparation for a central air conditioning system",
    "spec11": "Windows with insulating glass / triplex in the living room and bedrooms",
    "spec12": "Electric shutters in the living room and bedrooms",
    "spec13": "Closed circuit intercom with color screen",
    "spec14": "Porcelain granite flooring in sizes {{v}}/{{v}} with a selection of series and shades",
    "spec15": "Preparation for gas water heating",
    "spec16": "Solar water heating / heat pump",
    "spec17": "Electrical outlet and water faucet on the sun terrace",
    "spec18": "Designed security door in a wide range of colors with a lock or equivalent",
    "spec19": "Exchange switch in bedrooms",
    "spec20": "TV, telephone and computer communication preparation points in each room",
    "spec21": "Sun terrace including aluminum railings combined with glass",
    "spec22": "Three-phase electricity",
    "spec23": "Caesarstone or equivalent work surfaces in a choice of designs and colors",
    "spec24": "Ceramic tiling - in a choice of designs and colors",
    "spec25": "Acrylic or stainless steel kitchen sink with flat installation",
    "spec26": "Retractable kitchen faucet",
    "spec27": "Kitchen cabinets including I.B. units with quiet trick mechanisms",
    "spec28": "Connection to a water point for a refrigerator",
    "spec29": "Porcelain granite wall tiling up to ceiling height in bathrooms - in a selection of colors",
    "spec30": "Designed bathroom cabinets with an integrated sink in all bathrooms",
    "spec31": "Hanging toilets with hidden flushing mechanism",
    "spec32": "4-way intercom in general bathroom"
  },
  "specsShviro": {
    "category1": {
      "title": "Building",
      "spec1": "Luxurious stone cladding according to architect's selection",
      "spec2": "Prestigious entrance lobby with unique lighting designed by company architect",
      "spec3": "Luxurious floor lobby with unique cladding and prestigious flooring",
      "spec4": "Modern designed elevator at building entrance",
      "spec5": "Plot development including prestigious and designed landscaping",
      "spec6": "Spacious underground parking for residents' convenience",
      "spec7": "Luxurious and designed residents' club",
      "spec8": "Stroller/bicycle storage room"
    },
    "category2": {
      "title": "Apartment",
      "spec1": "80/80 porcelain granite flooring except in wet rooms",
      "spec2": "High-quality modern aluminum windows",
      "spec3": "Air conditioning system including dropped ceiling and AC installation according to HVAC consultant",
      "spec4": "Electric shutters in living room and bedrooms (except safe room)",
      "spec5": "Designer faucets",
      "spec6": "TV and telephone outlets in every room",
      "spec7": "Gewiss or equivalent sockets and switches",
      "spec8": "Light exchange switch in master bedroom and corridor",
      "spec9": "Three-phase electricity 25*3"
    },
    "category3": {
      "title": "Kitchen",
      "spec1": "Upper and lower kitchen cabinets including built-in units",
      "spec2": "Caesarstone or equivalent countertops - multiple colors for customer selection",
      "spec3": "Water point preparation for refrigerator",
      "spec4": "Dishwasher preparation",
      "spec5": "Electric cooktop preparation"
    },
    "category4": {
      "title": "Bathrooms",
      "spec1": "Luxury ceramic wall and floor tiling in bathrooms",
      "spec2": "Wall-mounted bathroom cabinets",
      "spec3": "Wall-hung toilets with concealed tanks in all bathrooms",
      "spec4": "4-way mixer in master or teen shower including rain shower head and hand shower",
      "spec5": "Bath mixer including overflow",
      "spec6": "White acrylic bathtub",
      "spec7": "Preparation for electric heating in bathrooms"
    },
    "category5": {
      "title": "Sun Terrace",
      "spec1": "Water and gas point in sun terrace",
      "spec2": "Anti-slip porcelain granite flooring with wood-like finish",
      "spec3": "Decorative glass railing combined with aluminum",
      "spec4": "Waterproof electrical outlet"
    },
    "category6": {
      "title": "Penthouse Apartments",
      "spec1": "Porcelain granite flooring in 100/100 or 60/120 dimensions"
    }
  },
  "specsHolon": {
    "spec1": "In the heart of the renewing Neve Arazim neighborhood, the NEW LIFE tower is being built - a unique residential project that brings a new standard of quality of life, meticulous design, and high living standards",
    "spec2": "The project features innovative architectural design by Jonathan Stein Architects, perfectly combining space, privacy, and functionality",
    "spec3": "The 10-story tower, located at 3 Yirmiyahu Street, offers a diverse mix of apartments including 3-5 room apartments, garden apartments, and stunning penthouses",
    "spec4": "Open view from the second floor",
    "spec5": "Underground parking with electric vehicle charging stations",
    "spec6": "Modern design and floor-to-ceiling windows for natural light and spacious feel",
    "spec7": "Rich technical specifications",
    "spec8": "Maximum accessibility to major transportation routes, public transportation and Green Line light rail stations, with everything close to home: parks, employment areas, shopping centers and quality educational institutions within walking distance"
  },
  "specsHavatzelet": {
    "category1": {
      "title": "Building and Environmental Development",
      "spec1": "Architecturally designed entrance lobby",
      "spec2": "Energy-efficient LED lighting in lobby and hallways",
      "spec3": "Landscaped grounds designed by landscape architect with decorative perimeter lighting",
      "spec4": "Private parking for each apartment in underground garage",
      "spec5": "Storage units for select apartments only",
      "spec6": "High-speed elevators with stainless steel and mirror finishes",
      "spec7": "Green building according to standard 5281",
      "spec8": "Preparation for electric vehicle charging system according to standards",
      "spec9": "Spacious underground parking garage"
    },
    "category2": {
      "title": "Apartment Features",
      "spec1": "Designer security door by Rav-Bariach or equivalent",
      "spec2": "Premium 'Laminato' series interior doors by Pandoor or equivalent",
      "spec3": "Central mini air conditioning system",
      "spec4": "High-quality 'Triplex'/insulated aluminum windows",
      "spec5": "Electric roller shutters in living room and bedrooms",
      "spec6": "Porcelain granite flooring in 100x100 cm dimensions with variety of colors to choose from in living room and bedrooms",
      "spec7": "Smart home electrical system for controlling lighting, electric shutters, water heater, and air conditioning in living areas",
      "spec8": "Three-phase electricity 3X25",
      "spec9": "Telephone, TV, and computer outlets in every room",
      "spec10": "7-inch color intercom screen in living unit with extension in master bedroom",
      "spec11": "Glass railings on balconies",
      "spec12": "Water and electrical outlets on balconies"
    },
    "category3": {
      "title": "Kitchen",
      "spec1": "Kitchen cabinets including I.B. unit with soft-close mechanisms",
      "spec2": "Caesarstone or equivalent countertop in variety of models and colors",
      "spec3": "Acrylic or stainless steel kitchen sink with flat installation",
      "spec4": "Pull-out kitchen faucet",
      "spec5": "Ceramic tiling - variety of models and colors to choose from",
      "spec6": "Water connection point for refrigerator"
    },
    "category4": {
      "title": "Bathrooms",
      "spec1": "Ceramic/porcelain granite flooring and wall tiling in bathrooms in variety of colors and sizes",
      "spec2": "Vanity cabinet and mirror in main bathroom and master bathroom",
      "spec3": "Designer 'Grohe' faucets or equivalent",
      "spec4": "Wall-hung toilets with concealed flush tanks in all bathrooms and toilets",
      "spec5": "Integrated bathroom cabinet with integrated mirror in all bathrooms",
      "spec6": "Acrylic bathtub with 4-way mixer including automatic filling and water point with shower rod and hand shower"
    }
  },
  "specsYuvalim": {
    "category1": {
      "title": "Building, Parking and Development",
      "spec1": "Designed buildings featuring a combination of several types of exterior cladding",
      "spec2": "High lobby with sophisticated design by interior designer",
      "spec3": "Stroller/bicycle room",
      "spec4": "High-speed elevators from leading companies",
      "spec5": "Underground parking garage with epoxy paint finish on floor",
      "spec6": "Rich landscaping and development planned by landscape architect",
      "spec7": "Equipped residents' room",
      "spec8": "Storage unit for each apartment"
    },
    "category2": {
      "title": "Aluminum Systems and Doors",
      "spec1": "Decorative and high-quality security entrance door",
      "spec2": "High-quality interior doors by Pandoor or equivalent",
      "spec3": "High-quality aluminum windows with double glazing",
      "spec4": "Electric roller shutters"
    },
    "category3": {
      "title": "Flooring and Wall Covering",
      "spec1": "Apartment flooring - rich selection of patterns from modern collection",
      "spec2": "Apartment flooring (except bathrooms and balconies) - porcelain granite in large dimensions approx. 100x100",
      "spec3": "Bathroom flooring and wall covering - porcelain granite in variety of models and dimensions such as 30/60, 25/70",
      "spec4": "Decorative tile integration in bathroom wall covering"
    },
    "category4": {
      "title": "Sanitary Arrangements",
      "spec1": "4-way mixer in shower/bathtub, including hand shower and fixed rain head/filling spout",
      "spec2": "Designer faucets from quality series including imported products",
      "spec3": "Wall-hung toilet with concealed flush tank",
      "spec4": "Designer cabinet including sink and integral surface in bathrooms",
      "spec5": "Kitchen sink - stainless steel, acrylic or granite with flat installation",
      "spec6": "Acrylic bathtub",
      "spec7": "Irrigation computer for apartments with planters adjacent to balconies"
    },
    "category5": {
      "title": "Kitchens",
      "spec1": "Luxury kitchen including built-in unit from leading companies",
      "spec2": "Integration of drawers with soft-close mechanism",
      "spec3": "Kitchen work surface of Caesarstone in variety of models to choose from"
    },
    "category6": {
      "title": "Electricity and Communications",
      "spec1": "Wireless smart home system",
      "spec2": "Three-phase apartment electrical connection",
      "spec3": "Telephone and television point in every room",
      "spec4": "Preparation for speakers in living room",
      "spec5": "Intercom with color screen at apartment entrance",
      "spec6": "High-quality electrical accessories such as Gewiss/Bticino/Nisko",
      "spec7": "Preparation for computer point in every room",
      "spec8": "Full supply and installation of apartment air conditioning system"
    }
  },
  "specsRassco": {
    "category1": {
      "title": "Apartment Specifications",
      "spec1": "\"Unique\" model interior doors by Pandoor company in a selection of colors or equivalent",
      "spec2": "Designer security door at apartment entrance",
      "spec3": "80*80 porcelain granite flooring in a wide variety of models and colors to choose from, 5 rooms 100*100",
      "spec4": "Aluminum windows with insulated or triplex glazing in bedrooms and living room showcase, safe room glass according to standard",
      "spec5": "150-liter electric water heater",
      "spec6": "Preparation for window screens (except tilt windows and safe room)",
      "spec7": "Variety of coverings and flooring to choose from"
    },
    "category2": {
      "title": "Bathrooms and Toilets",
      "spec1": "Mixer tap in shower and bathtub",
      "spec2": "Bathroom cabinet with integral sink in main bathroom",
      "spec3": "Non-slip flooring and wall covering with porcelain granite tiles in a selection of colors and models",
      "spec4": "Wall-hung toilets and concealed flush tanks",
      "spec5": "High-quality sanitary fixtures and faucets"
    },
    "category3": {
      "title": "Kitchen",
      "spec1": "Designer kitchen including upper shell, lower cabinets and BI unit (according to architect's design)",
      "spec2": "Soft-close mechanism in drawers",
      "spec3": "Sink with flat installation",
      "spec4": "High-quality Caesarstone work surface in a selection of colors",
      "spec5": "High-quality pull-out faucet",
      "spec6": "Preparation for dishwasher"
    },
    "category4": {
      "title": "Large and Spacious Sun Balcony",
      "spec1": "Water point",
      "spec2": "Electrical point"
    },
    "category5": {
      "title": "Electrical Systems",
      "spec1": "Electric roller shutters in living room and bedrooms (except safe room)",
      "spec2": "Luxury electrical accessories by Gewiss/Bticino or equivalent",
      "spec3": "Preparation for apartment air conditioning",
      "spec4": "Luxurious entrance lobby designed by interior designer",
      "spec5": "Fast and luxurious elevators, one elevator will serve as Sabbath elevator"
    },
    "category6": {
      "title": "In the Complex",
      "spec1": "Covered underground parking spaces"
    }
  },
  "introScreen": {
    "text1": "Live within reach of the promenade and the stunning beach strip",
    "text2": "Come grow and live within reach of nature and green quality of life",
    "text3": "The future neighborhood of the north is already here!"
  },
  "scheduling": {
    "appointment": {
      "bookOnlineTour": "Book an Online Tour",
      "editAppointment": "Edit Appointment",
      "selectDateTimePrompt": "Please select your preferred date and time for a callback from our expert.",
      "selectProject": "Select Project",
      "selectProjectPlaceholder": "Choose a project for this appointment",
      "projectRequired": "Project selection is required",
      "selectDate": "Select Date",
      "selectTime": "Select Time",
      "noAvailableDates": "No available dates for this project",
      "noAvailableTimeSlots": "No available time slots for this date",
      "duration": "Duration",
      "duration30Min": "30 minutes",
      "duration1Hour": "1 hour",
      "duration1_5Hours": "1.5 hours",
      "duration2Hours": "2 hours",
      "appointmentType": "Appointment Type",
      "googleMeet": "Google Meet",
      "physicalMeeting": "Physical Meeting",
      "notes": "Notes",
      "notesPlaceholder": "Additional information about the appointment",
      "continue": "Continue",
      "name": "Name",
      "namePlaceholder": "Name",
      "phone": "Phone",
      "phonePlaceholder": "Phone",
      "email": "Email",
      "emailPlaceholder": "Email",
      "bookAppointment": "Book Appointment",
      "updateAppointment": "Update Appointment",
      "creating": "Creating appointment...",
      "updating": "Updating appointment...",
      "updateSuccess": "Appointment updated successfully!",
      "updateError": "Failed to update appointment. Please try again.",
      "meetingSet": "Meeting Set!",
      "invitationSent": "The invitation and instructions have been sent to your email.",
      "appointmentWith": "Appointment with",
      "minutes": "minutes",
      "hour": "hour",
      "hours": "hours",
      "senderInformationWarning": "Email notifications won't be sent to clients because sender information is incomplete. Please configure sender name, email, and reply-to address in Email Settings.",
      "goToEmailSettings": "Go to Email Settings",
      "validation": {
        "nameRequired": "Name is required",
        "nameMinLength": "Name must be at least 2 characters",
        "nameMaxLength": "Name must be between 2-100 characters",
        "emailRequired": "Email is required",
        "emailInvalid": "Please enter a valid email address",
        "phoneRequired": "Phone number is required",
        "phoneInvalid": "Please enter a valid phone number"
      },
      "errors": {
        "validation": {
          "nameLength": "Name must be between 2-100 characters",
          "emailRequired": "Valid email is required",
          "phoneInvalid": "Invalid phone number format",
          "timeSlotNotFound": "Selected time slot not found",
          "futureDate": "Appointment must be scheduled for a future date",
          "allFieldsRequired": "Please fill in all required fields correctly"
        },
        "booking": {
          "failed": "Failed to book appointment. Please try again.",
          "timeSlotUnavailable": "This time slot is no longer available. Please select another time."
        },
        "network": {
          "connectionError": "Network error. Please check your connection and try again."
        }
      }
    },
    "appointmentDescription": {
      "contactInformation": "Contact Information",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "meetingType": "Meeting Type",
      "duration": "Duration",
      "minutes": "minutes",
      "notes": "Notes",
      "googleMeet": "Google Meet",
      "physicalMeeting": "Physical Meeting"
    },
    "noProjectsFound": "No projects found"
  }
}
